import { SaveResponse } from "src/models/api/save";
import { NIL, v4 as uuidv4 } from "uuid";

import { INewFile } from "./interfaces";
import { DocumentSTO } from "../../../models/documents";

import { DocumentFilesApiService } from "../../../services/documents/document-files-api.service";

import { toastifyResponse } from "../../../utils/toastify-response/toastify-response";

export const transformFileName = (fileName: string, orignalFileName: string): string => {
  const extension = orignalFileName.slice(((orignalFileName.lastIndexOf(".") - 1) >>> 0) + 2);

  return `${fileName}.${extension}`;
};

export const handleUploadNewFiles = async (
  document: DocumentSTO,
  newFiles: INewFile[],
  invokerId: string | null,
  correlationId: string | null,
  isGenericDocument?: boolean,
  doNotToastify?: boolean
): Promise<SaveResponse | void> => {
  for (let i = 0; i < newFiles.length; i++) {
    const newFile = newFiles[i];
    const { file, fileName } = newFile;

    const formData = new FormData();
    formData.append("id", uuidv4());
    formData.append("name", fileName ? transformFileName(fileName, file.name) : "");
    formData.append("isDeleted", false.toString());
    formData.append("documentId", document.id);
    formData.append("files[]", file, file?.name);
    // we pass ID below, thus it has to be initialized at least with NIL
    formData.append(
      "currentCompanyAccountId",
      isGenericDocument ? NIL : localStorage.getItem("currentCompanyAccountId") ?? NIL
    );

    if (document.legalEntity) {
      formData.append("legalEntityId", document.legalEntity.id);
    }

    const response = await new DocumentFilesApiService().saveItemsForm(
      formData,
      invokerId,
      correlationId,
      60,
      isGenericDocument
    );

    if (doNotToastify) {
      return response;
    } else {
      toastifyResponse(response, "failed", undefined, "failure_saving_file", "error_saving_file");
      if (!response.isSucceeded || response.isCanceled || !!response.error) return response;
    }
  }
};

export enum DocumentEvents {
  DOCUMENT_IS_MUTATED = "documentIsMutated",
  DOCUMENT_IS_SAVED = "documentIsSaved",
  DOCUMENT_IS_DELETED = "documentIsDeleted",
  DOCUMENT_IS_NOT_AUTHORIZED = "documentIsNotAuthorized",
}
